function TopicControlRegistrationParams(definition, group, path) {
    this.definition = definition;
    this.group = group;
    this.path = path;
}

module.exports = TopicControlRegistrationParams;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/topic-control-registration-params.js
// module id = 498
// module chunks = 0